export const getSubmissions = (personId) => {
  return `
    query {
      getSubmissions(${personId}) {
          result
          datetime
          personName
          status
          personId
          expireTime
          submissionKey
      }
    }
  `;
};

export const getBillingWorkflowByCustomerId = (customerId) => {
  return `
    query {
      getBillingWorkflowByCustomerId(${customerId}) {
        items {
          customerId
          billingWorkflowId
          description
          validFrom
          validTo
        }
      }
    }
  `;
};

export const getBillingWorkflowParameters = (billingWorkflowId) => {
  return `
    query {
      getBillingWorkflowParameters(${billingWorkflowId}) {
        name
        value
        lastModifiedDate
        version
      }
    }
  `;
};

export const getBillingRateInformation = (billingWorkflowId) => {
  return `
  query {
    getBillingRateInformation(billingWorkflowId: "${billingWorkflowId}")
  }`;
};


export const listBillingReportTypes = () => {
  return `
    query listBillingReportTypes {
      listBillingReportTypes {
        billingReportTypes {
          reportTypeId
          glCode
          invoiceLineItemId
          displayName
        }
        nextToken
      }
    }
  `;
};




// WEBPACK FOOTER //
// ./src/graphql/queries.js